/**
 * Context for company page layout mode (old vs new navigation).
 * @deprecated Delete this file when old nav is removed. See TODO in NewCompanyPage/index.tsx
 */
import { createContext, useContext, ReactNode } from 'react'

type LayoutMode = 'old' | 'new'

const CompanyPageContext = createContext<LayoutMode>('new')

interface CompanyPageProviderProps {
  mode: LayoutMode
  children: ReactNode
}

export function CompanyPageProvider({
  mode,
  children,
}: CompanyPageProviderProps) {
  return (
    <CompanyPageContext.Provider value={mode}>
      {children}
    </CompanyPageContext.Provider>
  )
}

/**
 * Hook to get the current layout mode.
 * Returns 'old' for old navigation, 'new' for new navigation.
 */
export function useCompanyPageLayout(): LayoutMode {
  return useContext(CompanyPageContext)
}

/**
 * Hook to check if we're in new navigation mode.
 */
export function useIsNewNavigation(): boolean {
  return useContext(CompanyPageContext) === 'new'
}
